import React, { useEffect, useState } from "react";
import { BiSolidQuoteAltRight, BiSolidQuoteAltLeft } from "react-icons/bi";
import Api_Instance from "../../api/Api_Instance";
import { TestimonialsEndpoints } from "../../api/endpoints";
import Slider from "react-slick";

function Hometestimonials() {
  const [testimonials, setTestimonials] = useState([]);
  const api = Api_Instance.unAuth();

  const GetTestimonials = async () => {
    try {
      const res = await api(
        "GET",
        `${TestimonialsEndpoints?.GET_TESTIMONIAL_API}?page_size=5&page=${1}`
      );
      const filteredData = res?.data?.data?.filter(item => item.status === true);
      setTestimonials(filteredData?.slice(0, 5));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetTestimonials();
  }, []);

  const truncateDescription = (description, wordLimit) => {
    const words = description?.split(" ");
    if (words.length > wordLimit) {
      return words?.slice(0, wordLimit)?.join(" ") + "...";
    }
    return description;
  };

  // Slider settings
  const settings = {
    autoplay: true,
    // dots: true,                // Show dots
    infinite: true,            // Enable infinite scrolling
    speed: 500,                // Animation speed
    slidesToShow: 1,           // Show 2 testimonials at a time
    slidesToScroll: 1,         // Scroll 1 testimonial at a time
    // Enable autoplay
    autoplaySpeed: 2000,       // Autoplay every 3 seconds
    responsive: [
      {
        breakpoint: 1024,      // For medium screens
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,       // For smaller screens
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  
  const Video = ({ item, index }) => {

    return (
      <div className="bg-[#f1f1f1] relative mt-[70px] pb-4 rounded-[30px]">
        <div className="w-[80%] mx-auto">
          <div className="relative">
            <div className="absolute  top-[56px] left-[-37px]">
              <BiSolidQuoteAltLeft
                className="text-[36px]"

              />
            </div>
            <div className="mb-3 pt-[80px]">
              <p className="text-center block-ellipsis">

                {truncateDescription(item.description, 30)}
              </p>
            </div>
            <div className="absolute right-[15px] bottom-[-29px]">
              <BiSolidQuoteAltRight
                className="text-[36px]"

              />
            </div>
          </div>
          <p className="ml-3 mt-5 text-center font-semibold capitalize">
            {item.director_name}
          </p>
        </div>
        <div className="w-[140px] h-[140px] rounded-full bg-[#000000] z-[20] absolute top-[-70px] left-0 right-0 mx-auto overflow-hidden border-[5px] border-[#FFFFFF]">
          <img
            src={item.image}
            alt="Profile"
            className="w-full h-full object-cover rounded-full"
          />
        </div>
      </div>

    )
  };
  const VideoItem = ({ item, index }) => {
    return (
      <div className="bg-[#f1f1f1] relative mt-[70px] pb-4 rounded-[30px]">
        <div className="w-[80%] mx-auto">
          <div className="relative">
            <div className="absolute top-[56px] left-[-37px]">
              <BiSolidQuoteAltLeft
                className="text-[36px]"

              />
            </div>
            <div className="mb-3 pt-[80px]">
              <p className="text-center block-ellipsis">

                {truncateDescription(item.description, 30)}
              </p>
            </div>
            <div className="absolute right-[15px] bottom-[-29px]">
              <BiSolidQuoteAltRight
                className="text-[36px]"

              />
            </div>
          </div>
          <p className="ml-3 mt-5 text-center font-semibold capitalize">
            {item.director_name}
          </p>
        </div>
        <div className="w-[140px] h-[140px] rounded-full bg-[#000000] z-[20] absolute top-[-70px] left-0 right-0 mx-auto overflow-hidden border-[5px] border-[#FFFFFF]">
          <img
            src={item.image}
            alt="Profile"
            className="w-full h-full object-cover rounded-full"
          />
        </div>
      </div>

    )
  };

  const renderVideos = () => {
    const visibleVideos = testimonials
    if (visibleVideos.length <= 1) {
      return (
        <div className='flex'>
          {visibleVideos?.map((item, index) => (
            <div className='w-[100%]'>
              <Video item={item} index={index} />
            </div>
          ))}
        </div>
      );
    }

    return (
      <Slider {...settings} >
        {visibleVideos?.map((item, index) => (
          <VideoItem item={item} index={index} />
        ))}
      </Slider>
    );
  };
  return (
    <div className="w-full max-w-[1250px]  mx-auto xl:px-0 lg:px-0 md:px-5 px-4 mb-5">
      <div className="mb-5">
        <h1 className="text-start font-bold 2xl:text-[32px] xl:text-[32px] lg:text-[32px] md:text-4xl text-2xl xl:mb-5 lg:mb-5 md:mb-5 mb-3 ">
          Our <span className="text-secondaryColor">Testimonials</span>
        </h1>
        <hr />
      </div>

      {renderVideos()}
    </div>
  );
}

export default Hometestimonials;
